import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { BingMapsContextProvider } from '@bingads-webui-react/bing-maps';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

// TODO: Send this in serverContext
const BING_MAPS_API_KEY = 'AgRuCtepgsuuCYV9J6S6w1j8ay2JJwnu8f5EPgv4kkoJoIuka8yui-NzKrvlESTQ';

export function withBingMapsContext(WrappedComponent) {
  const HOC = (props) => {
    const serverContext = useContext(ServerContext) as any;

    return (
      <BingMapsContextProvider
        campaignApiServiceRoot={`${serverContext.ServicesEndpoints.CampaignAPI}${serverContext.CampaignAPIPath}`}
        campaignApiToken={serverContext.Token}
        bingMapsApiKey={BING_MAPS_API_KEY}
      >
        <WrappedComponent {...props} />
      </BingMapsContextProvider>
    );
  };

  HOC.displayName = `withBingMapsContext(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
}
